<button type="button"
        class="option-dropdown-trigger"
        [class.is-open]="isOpen()"
        [class.tone-accent]="tone() === 'accent'"
        (click)="togglePanel($event)">
  <span class="trigger-label">{{ label() }}</span>
  <mat-icon class="trigger-arrow" [class.open]="isOpen()">expand_more</mat-icon>
</button>

@if (isOpen()) {
  <div class="option-dropdown-panel" (click)="$event.stopPropagation()">
    @for (option of options(); track option.value) {
      <button type="button" class="option-item" [title]="option.title ?? option.value" (click)="select(option)">
        @if (option.icon) {
          <span class="option-item__icon">{{ option.icon }}</span>
        }
        <span class="option-item__label">{{ option.label }}</span>
      </button>
    }
  </div>
}
